// [Brian 2026-10-27] Ask only for forwards with original attachments; ComposeRoute owns the choice and pop-out handoff.
export function ForwardAttachmentChoice({ value, onChange }: {
  value: boolean | null;
  onChange: (value: boolean) => void;
}) {
  return (
    <fieldset className="mx-4 my-2 rounded-lg border border-bmail-border px-3 py-2 text-sm text-bmail-text md:mx-6">
      <legend className="px-1 font-medium">Include attachments from the original email?</legend>
      <div className="flex flex-wrap gap-4">
        <label className="flex items-center gap-2 py-2">
          <input id="forward-attachments-yes" type="radio" name="forward-attachments" checked={value === true} onChange={() => onChange(true)} />
          Yes, include attachments
        </label>
        <label className="flex items-center gap-2 py-2">
          <input type="radio" name="forward-attachments" checked={value === false} onChange={() => onChange(false)} />
          No, message only
        </label>
      </div>
      <p className="text-bmail-text-secondary">The original message is included in the email body. Yes adds its files as attachments. Files you add yourself are included either way.</p>
    </fieldset>
  );
}
